module.exports = __webpack_public_path__ + "static/img/guoyin-logo.595840f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/guoyin-logo.png
// module id = nhLT
// module chunks = 1